import * as React from 'react'
import { AppRoute } from './types'
import {
  VehicleListPage,
  VehicleBasicDataPage,
  VehicleDailyActivityPage,
  VehicleWeeklyActivityPage,
  VehicleCalendarPage,
  VehicleBlocksPage,
} from './pages'
import VehiclesViewControlBar from './shared/viewBars/VehiclesViewControlBar'
import VehicleActivityBarWithDateWrapper from './shared/viewBars/VehicleActivityBarWithDateWrapper'
import VehicleBlocksBar from './shared/viewBars/VehicleBlocksBar'
import { VEHICLE_ROUTES } from './routes-typed'

// Source-of-truth for path strings: the typed routes in `routes-typed.ts`.
// Keeps this legacy map and the typed declarations from drifting apart.
export const vehiclesRoutesMap: Record<string, string> = {
  vehicleList: VEHICLE_ROUTES.list.path,
  vehicleBasicData: VEHICLE_ROUTES.basicData.path,
  vehicleDailyActivity: VEHICLE_ROUTES.dailyActivity.path,
  vehicleWeeklyActivity: VEHICLE_ROUTES.weeklyActivity.path,
  vehicleCalendar: VEHICLE_ROUTES.calendar.path,
  vehicleBlocksList: VEHICLE_ROUTES.blocksList.path,
  vehicleBlocksDetail: VEHICLE_ROUTES.blocksDetail.path,
}

export const vehiclesRoutes: AppRoute[] = [
  {
    path: vehiclesRoutesMap.vehicleBasicData,
    component: VehicleBasicDataPage,
    exact: true,
    heightScreen: true,

    navigation: true,
    viewControlBar: () => <VehicleBlocksBar blocks={false} />,
  },
  {
    path: vehiclesRoutesMap.vehicleList,
    component: VehicleListPage,
    exact: true,
    heightScreen: true,

    navigation: true,
    viewControlBar: () => <VehiclesViewControlBar />,
  },

  {
    path: vehiclesRoutesMap.vehicleDailyActivity,
    component: VehicleDailyActivityPage,
    exact: true,

    heightScreen: true,
    navigation: true,
    viewControlBar: () => <VehicleActivityBarWithDateWrapper />,
  },
  {
    path: vehiclesRoutesMap.vehicleWeeklyActivity,
    component: VehicleWeeklyActivityPage,
    exact: true,
    heightScreen: true,

    navigation: true,
    viewControlBar: () => <VehicleActivityBarWithDateWrapper />,
  },
  {
    path: vehiclesRoutesMap.vehicleCalendar,
    component: VehicleCalendarPage,
    exact: true,
    navigation: true,
    heightScreen: true,

    viewControlBar: () => <VehicleActivityBarWithDateWrapper />,
  },
  {
    path: vehiclesRoutesMap.vehicleBlocksDetail,
    component: VehicleBlocksPage,
    heightScreen: true,

    exact: true,
    navigation: true,
    viewControlBar: () => <VehicleBlocksBar />,
  },
  {
    path: vehiclesRoutesMap.vehicleBlocksList,
    component: VehicleBlocksPage,
    exact: true,
    heightScreen: true,

    navigation: true,
    viewControlBar: () => <VehiclesViewControlBar />,
  },
]
